import { Tag } from "primereact/tag";
import { useIntl } from "react-intl";

export const OptionalTag = () => {
  const intl = useIntl();
  return (
    <Tag
      data-testid="optional-tag"
      value={intl.formatMessage({ id: "optional" })}
      severity="info"
      rounded
    />
  );
};

export default OptionalTag;
